<template>
  <v-dialog
    :value="dialogs.twoFactorAuthBackupCodesDialog"
    max-width="1120"
    :transition="false"
    content-class="dialog-two-factor-radius"
    @click:outside="handleSubmit"
    @keydown.esc="handleSubmit"
  >
    <v-card
      class="dialog-two-factor-radius"
    >
      <v-card-title
        class="backup-codes-title"
        v-html="$t('twoFactor.copyBackupCodes')"
      >
        {{ $t('twoFactor.copyBackupCodes') }}
      </v-card-title>

      <v-card-text
        class="backup-codes-desc"
        v-html="$t('twoFactor.copyBackupCodeDesc')"
      >
      </v-card-text>

      <div class="backup-codes-header">
        <div class="backup-your-codes-title">
          {{ $t('twoFactor.yourCodes') }}
        </div>

        <div class="backup-codes-buttons-wrapper">
          <v-btn
            small
            rounded
            outlined
            color="primary"
            height="44"
            class="backup-button-text"
            @click="handleCopyAll"
          >
            {{ $t('common.copyAll') }}
          </v-btn>

          <v-btn
            small
            rounded
            outlined
            color="#666666"
            height="44"
            class="backup-button-text ml-2"
            :loading="loading"
            @click="handleResetCode"
          >
            {{ $t('twoFactor.resetCodes') }}
          </v-btn>
        </div>
      </div>

      <div class="backup-codes-section">
        <v-divider />

        <div class="backup-codes-wrapper">
          <div
            v-for="(code, index) in twoFactorBackupCodes"
            :key="index"
            class="backup-code"
          >
            {{ code }}
          </div>
        </div>

        <v-divider />

        <v-btn
          color="primary"
          width="320"
          height="44px"
          rounded
          class="mt-4 backup-submit-btn"
          @click="handleSubmit"
        >
          {{ $t('common.submit') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data () {
      return {
        loading: false
      }
    },

    computed: {
      ...mapGetters({
        dialogs: 'main/dialogs',
        twoFactorBackupCodes: 'main/twoFactorBackupCodes'
      }),
    },

    methods: {
      closeDialog () {
        this.$store.dispatch('main/closeDialog', 'twoFactorAuthBackupCodesDialog')
      },

      handleCopyAll () {
        navigator.clipboard.writeText(this.twoFactorBackupCodes.toString())
          .then(() => {
            this.$store.dispatch('main/alert', {
              color: '#6F6F6F',
              message: this.$t('common.copied')
            })
          })
          .catch(err => {
            console.log(`Error on copying all codes - ${err}`)
          })
      },

      async handleResetCode () {
        this.loading = true

        try {
          const newBackupCodesResponse = await this.api.put('two-factory/change-codes')

          if (newBackupCodesResponse.status === 200) {
            this.$store.dispatch('main/setTwoFactorBackupCodes', newBackupCodesResponse.data)

            this.$store.dispatch('main/alert', {
              color: '#6F6F6F',
              message: this.$t('twoFactor.successfullyResetedCodes')
            })
          }
        } catch (err) {
          console.log(`Error on reseting backup codes - ${error}`)
        } finally {
          this.loading = false
        }
      },

      handleSubmit () {
        this.closeDialog()

        this.$store.dispatch('main/closeDialog', 'enableTwoFactorAuthDialog')
        this.$store.dispatch('main/closeDialog', 'popTwoFactor')
      }
    }
  }
</script>

<style>
  .dialog-two-factor-radius {
    border-radius: 34px!important;
  }

  .backup-codes-title {
    font-weight: 500!important;
    font-size: 34px!important;
    line-height: 40px!important;
    letter-spacing: 0.25px!important;
    color: #212121!important;
    padding: 32px 32px 16px 32px!important;
    width: 100%;
    justify-content: center;
    text-align: center;
  }

  .backup-codes-desc {
    padding: 0 32px !important;
    font-style: normal;
    font-weight: 400 !important;
    font-size: 16px!important;
    line-height: 19px!important;
    letter-spacing: 0.5px!important;
    color: #212121!important;
    justify-content: center;
    text-align: center;
  }

  .backup-codes-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 32px 15px 32px;
  }

  .backup-your-codes-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.15px;
    color: #212121;
  }

  .backup-button-text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.5px;
    text-transform: unset;
  }

  .backup-codes-wrapper {
    margin: 32px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 12px 4px;
    justify-content: center;
  }

  .backup-code {
    height: 53px;
    padding: 12px 16px;
    background: #EFEFEF;
    border-radius: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    letter-spacing: 0.5px;
    color: #000000;
  }

  .backup-codes-section {
    padding: 0 32px 32px 32px;
    display: flex;
    flex-direction: column;
  }

  .backup-submit-btn {
    text-transform: unset;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.5px;
    color: #FFFFFF;
    display: flex;
    align-self: center;
  }
</style>
